import React from "react";
import {
  designColors,
  designFontFamily,
} from "services/constants/designTokens";

export const StatusRow = ({ status, user, date, showConnector }) => {
  const color =
    status === "approved"
      ? "#0BB783"
      : status === "applied"
        ? "#3699FF"
        : status === "rejected"
          ? "#F64E60"
          : status === "cancelled"
            ? "#6B7280"
          : status === "rejectReason"
            ? "#F64E60"
            : status === "cancelReason"
              ? "#6B7280"
              : "#C19A6B";

  const titleMap = {
    applied: "Applied by",
    approved: "Approved by",
    rejected: "Rejected by",
    cancelled: "Cancelled by",
    reason: "Reason for Applying:",
    rejectReason: "Reason for Rejection:",
    cancelReason: "Reason for Cancellation:",
  };

  return (
    <div
      style={{
        position: "relative",
        paddingLeft: 20,
        marginBottom: showConnector ? 18 : 0,
        // Plain HTML elements, not Mui.Typography — they don't pick up
        // the design system's Poppins font from a <ThemeProvider> the way
        // MUI components do, so it has to be set explicitly here (once,
        // inherited by every span below) instead of silently falling back
        // to the browser default font.
        fontFamily: designFontFamily,
        fontSize: 14,
        fontWeight: 400,
        color: designColors.slate900,
      }}
    >
      <div
        style={{
          width: 10,
          height: 10,
          borderRadius: "50%",
          backgroundColor: color,
          position: "absolute",
          left: 0,
          top: 6,
        }}
      />

      {showConnector && (
        <div
          style={{
            position: "absolute",
            left: 4,
            top: 18,
            width: 2,
            height: 25,
            backgroundColor: "#C4C4C4",
          }}
        />
      )}

      <div style={{ display: "flex", gap: 6, marginTop: 2, flexWrap: "wrap" }}>
        <span style={{ fontWeight: 500 }}>{titleMap[status]}</span>

        {status === "reason" ||
        status === "rejectReason" ||
        status === "cancelReason" ||
        status === "description" ? (
          <span>{user ?? "-"}</span>
        ) : (
          <>
            <span>{user ?? "-"}</span>
            <span style={{ fontWeight: 600 }}>on</span>
            <span>{date ?? "-"}</span>
          </>
        )}
      </div>
    </div>
  );
};
